export default "__VITE_ASSET__ChryL6DP__"